export enum ProductAdviceType {
	Unsupported,
	New,
	Renew,
	Running,
	TradeIn,
	Terminate,
}
